import React, { useState } from 'react';
import Button from './ui/Button';
import EditText from './ui/EditText';
import TextArea from './ui/TextArea';
import unionBg from '../../Assets/Images/seekjob/Union.png';
import { website_inquiry } from '../../Services/Website/WebsiteApi';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ContactForm = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [userType, setUserType] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [statusMessage, setStatusMessage] = useState({
    show: false,
    type: '', // 'success' or 'error'
    text: '',
  });
  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!firstName.trim()) newErrors.firstName = 'First name is required';
    if (!lastName.trim()) newErrors.lastName = 'Last name is required';
    if (!email.trim()) newErrors.email = 'Email is required';
    if (!userType.trim()) newErrors.userType = 'Please select a user type';
    if (!message.trim()) newErrors.message = 'Message is required';

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setStatusMessage({
        show: true,
        type: 'error',
        text: 'Please fill out all required fields.',
      });
      return;
    }

    const apiParam = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      role: userType,
      message: message,
    };

    setIsSubmitting(true);

    try {
      const data = await website_inquiry(apiParam);
      if (data?.code === "ERR_BAD_REQUEST") {
        throw new Error(data.response.data.error || 'Request failed');
      }

      setStatusMessage({
        show: true,
        type: 'success',
        text: data?.message || 'Inquiry submitted successfully!',
      });

      setFirstName('');
      setLastName('');
      setEmail('');
      setMessage('');
      setUserType('');
      setErrors({});
    } catch (error) {
      console.error('Error:', error);
      setStatusMessage({
        show: true,
        type: 'error',
        text:
          error?.response?.data?.error ||
          error?.message ||
          'Something went wrong. Please try again.',
      });
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <div id='ContactUs'
      className="tw-w-full tw-bg-cover tw-bg-center tw-bg-no-repeat tw-pt-[5rem] tw-pb-[5rem] tw-relative tw-z-[1000]"
      style={{
        backgroundImage: `url(${unionBg})`,
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      <div className="tw-w-full tw-max-w-[1680px] tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        <ToastContainer position="top-right" autoClose={3000} />
        <div className="tw-flex tw-flex-col tw-gap-8 lg:tw-gap-12 tw-items-center">
          <h2 className="tw-text-[36px] sm:tw-text-[60px] lg:tw-text-[75px] tw-leading-[44px] sm:tw-leading-[72px] lg:tw-leading-[117px] tw-font-inter tw-font-semibold tw-text-left tw-text-white">
            Ready to level up your career game?
          </h2>

          <div className="tw-w-full tw-max-w-4xl tw-relative tw-overflow-hidden tw-rounded-3xl tw-bg-[linear-gradient(#1E1E1E,_#3A3A3A)] tw-border tw-border-solid tw-border-white tw-p-6 lg:tw-p-8">
            <div
              className="tw-absolute tw-inset-0 tw-z-0"
              style={{
                pointerEvents: 'none',
                backgroundImage:
                  'radial-gradient(circle at 6.3px 3.3px, rgba(255, 255, 255, 0) 0.3px, #00000033 3px), linear-gradient(rgb(30, 30, 30), rgb(58, 58, 58))',
                backgroundSize: '30px 30px, cover',
                backgroundRepeat: 'repeat, no-repeat',
                backgroundPosition: '0 0, center',
              }}
            />

            <form
              onSubmit={handleSubmit}
              className="tw-relative tw-z-10 tw-flex tw-flex-col tw-gap-6 lg:tw-gap-8"
            >
              {/* Name Fields */}
              <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-4 lg:tw-gap-6">
                <div className="tw-flex tw-flex-col tw-gap-1 tw-w-full">
                  <label className="tw-text-[12px] lg:tw-text-[14px] tw-font-inter tw-font-semibold tw-text-white">
                    First Name *
                  </label>
                  <EditText
                    placeholder="John"
                    value={firstName}
                    onChange={(e) => {
                      const filteredValue = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                      setFirstName(filteredValue)
                    }}
                    className={`tw-bg-transparent tw-border-global-6 ${errors.firstName ? 'tw-border-red-500' : ''}`}
                  />
                  {errors.firstName && <span className="tw-text-red-500 tw-text-xs">{errors.firstName}</span>}
                </div>

                <div className="tw-flex tw-flex-col tw-gap-1 tw-w-full">
                  <label className="tw-text-[12px] lg:tw-text-[14px] tw-font-inter tw-font-semibold tw-text-white">
                    Last Name *
                  </label>
                  <EditText
                    placeholder="Doe"
                    value={lastName}
                    onChange={(e) => {
                      const filteredValue = e.target.value.replace(/[^a-zA-Z\s]/g, "");
                      setLastName(filteredValue)
                    }}
                    className={`tw-bg-transparent tw-border-global-6 ${errors.lastName ? 'tw-border-red-500' : ''}`}
                  />
                  {errors.lastName && <span className="tw-text-red-500 tw-text-xs">{errors.lastName}</span>}
                </div>
              </div>

              {/* Email and User Type */}
              <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-4 lg:tw-gap-6">
                <div className="tw-flex tw-flex-col tw-gap-1 tw-w-full">
                  <label className="tw-text-[12px] lg:tw-text-[14px] tw-font-inter tw-font-semibold tw-text-white">
                    Email Address *
                  </label>
                  <EditText
                    type="email"
                    placeholder="johndoe@example.edu"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className={`tw-bg-transparent tw-border-global-6 ${errors.email ? 'tw-border-red-500' : ''}`}
                  />
                  {errors.email && <span className="tw-text-red-500 tw-text-xs">{errors.email}</span>}
                </div>

                <div className="tw-flex tw-flex-col tw-gap-3 tw-w-full">
                  <label className="tw-text-[12px] lg:tw-text-[14px] tw-font-inter tw-font-semibold tw-text-white">
                    I am *
                  </label>
                  <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-3 lg:tw-gap-4">
                    {['student', 'career-partner', 'employer'].map((type) => (
                      <label key={type} className="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer">
                        <input
                          type="radio"
                          name="userType"
                          value={type}
                          checked={userType === type}
                          onChange={(e) => setUserType(e.target.value)}
                          className={`tw-w-4 tw-h-4 tw-border tw-border-global-9 tw-rounded ${errors.userType ? 'tw-border-red-500' : ''}`}
                        />
                        <span className="tw-text-[12px] lg:tw-text-[14px] tw-font-inter tw-font-semibold tw-text-white">
                          {type.replace('-', ' ').replace(/\b\w/g, (l) => l.toUpperCase())}
                        </span>
                      </label>
                    ))}
                  </div>
                  {errors.userType && <span className="tw-text-red-500 tw-text-xs">{errors.userType}</span>}
                </div>
              </div>

              {/* Message Field */}
              <div className="tw-flex tw-flex-col tw-gap-1">
                <label className="tw-text-[12px] lg:tw-text-[14px] tw-font-inter tw-font-semibold tw-text-white">
                  Message *
                </label>
                <TextArea
                  placeholder="Enter Your Message"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  rows={4}
                  className={`tw-bg-transparent tw-border-global-6 tw-text-white tw-placeholder-white ${errors.message ? 'tw-border-red-500' : ''}`}
                />
                {errors.message && <span className="tw-text-red-500 tw-text-xs">{errors.message}</span>}
              </div>

              {/* Submit Button */}
              <Button
                type="submit"
                variant="gradient"
                size="large"
                disabled={isSubmitting}
                leftImage={
                  !isSubmitting && {
                    src: '/images/img_icon.svg',
                    width: 12,
                    height: 12,
                  }
                }
                className={`tw-flex tw-border-none tw-items-center tw-border-none tw-justify-center tw-gap-2 tw-bg-[#0843FE] tw-text-white tw-p-[13px] tw-rounded ${isSubmitting ? 'tw-opacity-60 tw-cursor-not-allowed' : ''
                  }`}
                style={{ border: 'none' }}
              >
                {!isSubmitting && (
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/SvgIcon/send.svg`}
                    alt=""
                    className="tw-w-5 tw-h-5"
                  />
                )}
                {isSubmitting ? 'Sending...' : 'Send Message'}
              </Button>
            </form>
          </div>
        </div>
      </div>
      {statusMessage.show && (
        <div className="tw-fixed tw-inset-0 tw-bg-black/40 tw-flex tw-items-center tw-justify-center tw-z-50">
          <div className="tw-bg-white tw-rounded-lg tw-shadow-lg tw-p-6 tw-max-w-md tw-w-full tw-text-center">
            <h2
              className={`tw-text-lg tw-font-semibold ${statusMessage.type === 'success'
                ? 'tw-text-green-600'
                : 'tw-text-red-600'
                }`}
            >
              {statusMessage.type === 'success' ? 'Success' : 'Error'}
            </h2>
            <p className="tw-mt-2 tw-text-sm tw-text-gray-700">{statusMessage.text}</p>
            <button
              className="tw-mt-4 tw-px-4 tw-py-2 tw-bg-[#0843FE] tw-border-none tw-text-white tw-rounded hover:tw-bg-blue-700"
              onClick={() => setStatusMessage({ show: false, type: '', text: '' })}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactForm;
